export const copy = {
  assistantMessage:
    "Thanks for chatting with Twilio support! This conversation has been closed and was recorded into a ticket. You can go back to the home screen, view the transcript in the ticket details page, or provide feedback.",
};
